import ActionTypes from "../../../../constants/ActionTypes";
import { ICampaignAcceptanceState } from "./types";

const initialState: ICampaignAcceptanceState = {
  tp: null,
  optionName: '',
  acceptanceStatus: false,
  terms: ''
};

const campaignAcceptanceReducer = (
  state = initialState,
  action: any,
): any => {
  switch (action.type) {
  case ActionTypes.CAMPAIGN.ACCEPTANCE.SET_ACCEPTANCE_OFFER_PACKAGE:
    return {
      ...state,
      tp: action.payload
    };
  case ActionTypes.CAMPAIGN.ACCEPTANCE.SET_ACCEPTANCE_OPTION_NAME:
    return {
      ...state,
      optionName: action.payload
    };
  case ActionTypes.CAMPAIGN.ACCEPTANCE.SET_STATUS:
    return {
      ...state,
      acceptanceStatus: action.status
    };
  case ActionTypes.CAMPAIGN.ACCEPTANCE.SET_TERMS:
    return {
      ...state,
      terms: action.payload
    };
  }
  return state;
};

export default campaignAcceptanceReducer;

